import { render, staticRenderFns } from "./auth.vue?vue&type=template&id=a3f52324&scoped=true"
import script from "./auth.vue?vue&type=script&lang=js"
export * from "./auth.vue?vue&type=script&lang=js"
import style0 from "./auth.vue?vue&type=style&index=0&id=a3f52324&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f52324",
  null
  
)

export default component.exports